/* tslint:disable */
/* eslint-disable */
/**
 * Sellsen API
 * Ürün Tarama ve SP-API Entegrasyonu
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BuyerEmailItemDTOFromJSON, BuyerEmailItemDTOToJSON, } from './BuyerEmailItemDTO';
/**
 * Check if a given object implements the BuyerEmailImportRequest interface.
 */
export function instanceOfBuyerEmailImportRequest(value) {
    if (!('orders' in value) || value['orders'] === undefined)
        return false;
    return true;
}
export function BuyerEmailImportRequestFromJSON(json) {
    return BuyerEmailImportRequestFromJSONTyped(json, false);
}
export function BuyerEmailImportRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orders': (json['orders'].map(BuyerEmailItemDTOFromJSON)),
    };
}
export function BuyerEmailImportRequestToJSON(json) {
    return BuyerEmailImportRequestToJSONTyped(json, false);
}
export function BuyerEmailImportRequestToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orders': (value['orders'].map(BuyerEmailItemDTOToJSON)),
    };
}
